import { createRoot } from "react-dom/client";
import { flushSync } from "react-dom";
import { LegendBox } from "../LegendBox";
import type { RenderLegendSvgString } from "./types";

export const renderLegendSvgString: RenderLegendSvgString = ({
  pdfPageWidth,
  pdfPageHeight,
  pixelWidth,
  pixelHeight,
  items,
  summary,
  x,
  y,
  scale,
}) => {
  const detachedContainer = document.createElement("div");
  const root = createRoot(detachedContainer);

  try {
    flushSync(() => {
      root.render(
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox={`0 0 ${pdfPageWidth} ${pdfPageHeight}`}
          width={pixelWidth}
          height={pixelHeight}
        >
          <LegendBox
            x={x}
            y={y}
            items={items}
            summary={summary}
            scale={scale}
          />
        </svg>,
      );
    });

    const svgElement = detachedContainer.querySelector("svg");
    if (!svgElement) {
      throw new Error("SVG element not found in legend render output");
    }

    return new XMLSerializer().serializeToString(svgElement);
  } finally {
    root.unmount();
  }
};
